<script lang="ts">
	//UI
	import EditSave from "@hitit/mbr/src/v7/component/Common/EditSave.svelte";

	//Utils
	import { t } from "@hitit/hub/src/stores";
	import { InlineButton, AdaptiveTextInput } from "@hitit/new_ui";
	import { createEventDispatcher } from "svelte";
	//Types
	//Props
	export let editmode = false;
	export let actionHandler = () => {};
	export let collections: { name: string; getLength: () => number }[] = [];
	export let selectedName = "";
	//Constants
	const placeholder = "카테고리 명";
	const dispatch = createEventDispatcher();
	//Variables
	let inputText = "";
	let inputError = false;
	//Functions
	function newCollectionHandler() {
		const emptyCondition = inputText === "";
		const sameNameCondition =
			collections.find((v) => v.name === inputText) !== undefined;

		if (emptyCondition || sameNameCondition) return (inputError = true);

		dispatch("CREATE_NEW_COLLECTION", inputText);
		inputText = "";
	}

	function collectionClickHandler(name: string) {
		dispatch("COLLECTION_CLICK", name);
	}

	//Do

</script>

<div class="container">
	<div class="actions">
		<EditSave
			editmode={editmode}
			actionHandler={actionHandler}
			_static
			doneText={$t('global.save_changes')} />
	</div>
	<div class="collections">
		<div class="dummy" />
		{#each collections as collection}
			<InlineButton on:click={() => collectionClickHandler(collection.name)}>
				<span
					class:selected={selectedName === collection.name}
					class="collection">
					{collection.name}{' '}({collection.getLength()})
				</span>
			</InlineButton>
		{/each}
		{#if editmode}
			<div id="new-collection">
				<div id="new-collection-input">
					<AdaptiveTextInput
						bind:value={inputText}
						on:input={() => (inputError = false)}
						placeholder={placeholder}
						error={inputError} />
				</div>
				<InlineButton on:click={newCollectionHandler}>
					<span id="new-collection-inner-button"> {$t('global.ok')} </span>
				</InlineButton>
			</div>
		{/if}
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		display: flex;
		width: 100%;
		flex-direction: column;
		gap: 20px;

		.actions {
			display: flex;
			flex-direction: row-reverse;
			white-space: pre;
		}
		.collections {
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			gap: 20px;
			.dummy {
				display: none;
			}
			.collection {
				font-weight: 500;
				color: #6d6f76;
				&.selected {
					color: #3c68d6;
					font-weight: 550;
				}
			}
		}
		#new-collection {
			display: flex;
			align-items: center;
			gap: 10px;

			#new-collection-input {
				font-size: 1rem;
				font-weight: 500;
				color: #6d6f76;
				width: 100px;
				height: 30px;
			}

			#new-collection-inner-button {
				font-size: 1rem;
				color: #6d6f76;
				font-weight: 500;
			}
		}
	}

	@include DesktopSize {
		.container {
			flex-direction: row-reverse;

			.actions {
				font-size: 1.25rem;
				height: 40px;
			}

			.collections {
				flex-grow: 1;
				align-items: center;
				font-size: 1.25rem;
				gap: 20px 30px;
				.dummy {
					display: block;
					margin-right: -30px;
					height: 40px;
				}
			}
			#new-collection {
				display: flex;
				align-items: center;
				gap: 10px;
				font-size: 1.25rem;

				#new-collection-inner-button {
					font-size: 1.25rem;
					color: #6d6f76;
					font-weight: 500;
				}
				#new-collection-input {
					font-size: 1.25rem;
					width: 200px;
					height: 40px;
				}
			}
		}
	}

</style>
